<i18n>
{
  "ja": {
    "search-criteria": "検索条件",
    "search-hit": "<span class='text-3xl font-bold text-secondary'>{count}</span><span class='text-sm mt-1 ml-1 font-bold'>件がヒットします</span>",
    "no-hit": "該当する倉庫がありません",
    "search-by-condition": "条件を変更して検索",
    "prefectures": "都道府県",
    "area": "エリア",
    "trucksize-available": "対応可能なトラックサイズ",
    "close": "閉じる",
    "all": "全て"
  }
}
</i18n>
<template>
  <div class="p-6">
    <div class="mobile-padding lg:hidden text-right w-full py-4">
      <img src="~assets/img/warehouse/cross-hair.svg" class="inline-block" alt="close" @click="close" />
    </div>
    <header class="text-center text-xl">
      <div class="font-bold">{{ $t('search-criteria') }}</div>
      <hr class="border-black my-6 mx-4" />
    </header>
    <div class="mt-8">
      <span v-if="totalCount > 0" class="flex items-center justify-center" v-html="$t('search-hit', {count: totalCount})"></span>
      <span v-else class="flex items-center justify-center text-sm" v-html="$t('no-hit')"></span>
    </div>
    <form class="text-left">
      <div class="form-item">
        <label class="form-item-label">{{ $t('prefectures') }}</label>
        <select class="search-province input-select" v-model="query.prefecture">
          <option v-for="(value, name, index) in prefectures" :key="index" :value="value">
            {{ value }}
          </option>
        </select>
      </div>
      <div class="form-item">
        <label class="form-item-label">{{ $t('area') }}</label>
        <select class="search-area input-select" v-model="query.area">
          <option :value="null">{{ $t('all') }}</option>
          <option v-for="(value, index) in areaList" :key="index" :value="value">
            {{ value }}{{ $t('area') }}
          </option>
        </select>
      </div>
      <div class="form-item">
        <label class="form-item-label">{{ $t('warehouse.temperature') }}</label>
        <select class="search-temperature input-select" v-model="query.temperature">
          <option :value="null || undefined">{{ $t('all') }}</option>
          <option value="normal">{{$t('warehouse.normal')}}</option>
          <option value="constant">{{$t('warehouse.constant')}}</option>
        </select>
      </div>
      <div class="form-item">
        <label class="form-item-label">{{ $t('warehouse.structure') }}</label>
        <select class="search-structure input-select" v-model="query.structure">
          <option :value="null || undefined">{{ $t('all') }}</option>
          <option value="wooden">{{$t('warehouse.wooden')}}</option>
          <option value="non-wooden">{{$t('warehouse.non-wooden')}}</option>
        </select>
      </div>
      <div class="form-item">
        <label class="form-item-label">{{ $t('trucksize-available') }}</label>
        <select class="search-trucksize input-select" v-model="query.trucksize">
          <option :value="null || undefined">{{ $t('all') }}</option>
          <option value="upto_40ft">{{$t('search.upto_40ft')}}</option>
          <option value="upto_10t">{{$t('search.upto_10t')}}</option>
          <option value="upto_4t">{{$t('search.upto_4t')}}</option>
          <option value="upto_2t">{{$t('search.upto_2t')}}</option>
        </select>
      </div>
      <div class="form-item">
        <label class="form-item-label">{{ $t('warehouse.other') }}</label>
        <checkbox :value.sync="query.saturdays" :label="$t('search.saturdays')" class-name="search-saturdays" />
        <checkbox :value.sync="query.sundays" :label="$t('search.sundays')" class-name="search-sundays" />
        <checkbox :value.sync="query.holidays" :label="$t('search.holidays')" class-name="search-holidays" />
        <checkbox :value.sync="query.deliveryservice" :label="$t('search.deliveryservice')" class-name="search-deliveryservice" />
        <checkbox :value.sync="query.property_port" :label="$t('search.property_port')" class-name="search-property-port" />
        <checkbox :value.sync="query.property_bonded" :label="$t('search.property_bonded')" class-name="search-property-bonded" />
      </div>
      <div class="form-item mb-10 lg:mb-4">
        <button
          type="button"
          class="btn-search mb-2 w-full rounded-full py-3 px-4 focus:outline-none font-bold text-white flex justify-center"
          @click="search"
        >
          <span>{{ $t('search-by-condition') }}</span>
          <span class="material-icons ml-2">search</span>
        </button>
      </div>
    </form>
  </div>

</template>

<style lang="sass" scoped>
.btn-search
  @apply bg-accent
select
  @apply p-2 w-full border border-gray-300
.form-item
  @apply mt-6
  .form-item-label
    @apply text-xs font-bold block
</style>

<script>
import Checkbox from '@/components/checkbox';

export default {
  components: { Checkbox },
  props: {
    query: { type: Object, required: true },
    areas: { type: Array, required: true },
    totalCount: { type: Number, required: true }
  },
  computed: {
    prefectures () {
      let prefs = [];
      Object.keys(this.$t('areas')).forEach((key) => {
        prefs = prefs.concat(Object.values(this.$t(`${key}-prefectures`)));
      });
      return prefs;
    },
    areaList () {
      const areaData = this.areas.find(item => item.prefecture === this.query.prefecture);
      return areaData ? areaData.areas : [];
    },
  },
  watch: {
    'query.prefecture'() {
      this.query.area = null;
    },
  },
  methods: {
    search () {
      this.$emit('search', this.query);
    },
    close () {
      this.$emit('close');
    },
  }
}
</script>